import { createFileRoute } from "@tanstack/react-router";

import { ClientTabPage } from "@/features/booking/modules/client-page/client-tab-page";
import { BillingActions, ClientBilling } from "@/features/finance/modules/client-billing/client-billing";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/trainees/$clientId/billing")({
  loader: () => ({ crumb: m.client_tab_billing() }),
  component: RouteComponent,
});

function RouteComponent() {
  const { clientId } = Route.useParams();
  return (
    <ClientTabPage clientId={clientId} tab="billing" actions={<BillingActions clientId={clientId} />}>
      <ClientBilling clientId={clientId} />
    </ClientTabPage>
  );
}
